import api from './api';

const productsService = {
  // Listar todos os produtos
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/products', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar produtos:', error);
      throw error;
    }
  },

  // Buscar produto por ID
  getById: async (id) => {
    try {
      const response = await api.get(`/products/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar produto:', error);
      throw error;
    }
  },

  // Criar produto
  create: async (data) => {
    try {
      const response = await api.post('/products', data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar produto:', error);
      throw error;
    }
  },

  // Atualizar produto
  update: async (id, data) => {
    try {
      const response = await api.put(`/products/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar produto:', error);
      throw error;
    }
  },

  // Inativar produto (soft delete)
  inactivate: async (id) => {
    try {
      const response = await api.put(`/products/${id}/inativar`);
      return response.data;
    } catch (error) {
      console.error('Erro ao inativar produto:', error);
      throw error;
    }
  },

  // Deletar produto definitivamente (hard delete)
  delete: async (id) => {
    try {
      const response = await api.delete(`/products/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar produto:', error);
      throw error;
    }
  },

  // Listar categorias
  getCategories: async () => {
    try {
      const response = await api.get('/products/categorias');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar categorias:', error);
      throw error;
    }
  },

  // Listar marcas
  getBrands: async () => {
    try {
      const response = await api.get('/products/marcas');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar marcas:', error);
      throw error;
    }
  }
};

export default productsService;
